import { LoaderFunction, LoaderFunctionArgs, redirect } from "react-router";
import { Session } from "@supabase/supabase-js";
import { supabase } from "./supabaseClient";

type AuthLoaderArgs = LoaderFunctionArgs & { session: Session };

export const requireAuth =
  <T,>(loader?: (args: AuthLoaderArgs) => T | Promise<T>): LoaderFunction =>
  async (args) => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) return redirect("/login");
    return loader ? loader({ ...args, session }) : session;
  };

export const requireGuest =
  <T,>(loader?: (args: LoaderFunctionArgs) => T | Promise<T>): LoaderFunction =>
  async (args) => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (session) return redirect("/app");
    return loader ? loader(args) : null;
  };
